import React from 'react';
import './PastEvents.css';

import aditya from '../assets/posters/adityabadge.jpg';
import amit from '../assets/posters/amitbadge.jpg';
import swarwel from '../assets/posters/swarwelbadge.jpg';
import tejas from '../assets/posters/tejasbadge.jpg';
import prem from '../assets/posters/prembadge.jpg';
import ritesh from '../assets/posters/riteshbadge.jpg';

const pastPosters = [
    aditya,
    amit,
    swarwel,
    tejas,
    prem,
    ritesh
];


const PastEvents = () => {
    return (
        <section className="past-events-section">
            <div className="posters-carousel-container">
                {/* This track will scroll in the reverse direction */}
                <div className="posters-carousel-track-reverse">
                    {/* Render posters twice for a seamless loop */}
                    {pastPosters.map((poster, index) => (
                        <div className="poster-card" key={`past1-${index}`}>
                            <img src={poster} alt={`Past Event Poster ${index + 1}`} />
                        </div>
                    ))}
                    {pastPosters.map((poster, index) => (
                        <div className="poster-card" key={`past2-${index}`}>
                            <img src={poster} alt={`Past Event Poster ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PastEvents;
